import { supabase } from '../services/supabaseClient.js';

// Ops/reliability log → public.system_events. Fire-and-forget; never blocks or
// throws. Unlike marketing telemetry (utils/track.js) this is NOT suppressed on
// internal devices — we want every reliability fallback, including QA sessions.
// metadata is free-form jsonb (the admin view reads lesson + phase from it).
export async function logSystemEvent(eventType, metadata = {}) {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    await supabase.from('system_events').insert({
      user_id: session?.user?.id || null,
      event_type: eventType,
      metadata,
    });
  } catch {
    // swallow — telemetry must never affect the learner flow
  }
}
